import React from 'react';
import '../../styles/footer.css';

function Footer() {
    return (
        <footer className="footer">
            {/* globe returns to the main site index */}
            <a href="/" aria-label="barinderthind.com">
                <i className="fa fa-globe fa-2x" aria-hidden="true"></i>
            </a>
            <br />
            &copy; 2024 NLP Begin
        </footer>
    );
}

export default Footer;
